import UtilsService from "app/services/utils/utils.service";
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";

const NS = 'ChildMenuOptions';
const PLACEHOLDER = 'Search';

// requiring html templates so that hot reloading works
const template = require('./childMenuOptions.html');

export default function ChildMenuOptions() {
    return {
        restrict: 'E',
        replace: true,
        controllerAs: 'vm',
        template,
        scope: {
            tags: '=',
            disabled: '=',
            parentId: '=',
            title: '@'
        },
        controller
    }
}

function controller($scope, $element, unregister, hardCodedTags) {
    "ngInject";

    let vm = this;
    let allMenuOptions;
    let listeners;
    //-- define public properties
    vm.remainingMenuOptions = [];
    vm.placeholder = PLACEHOLDER;
    //-- define public methods
    vm.onAddTag = onAddTag;
    vm.removedTag = removedTag;
    vm.querySearch = querySearch;

    const MAX_TAGS_INTERVALS = 10;
    let tagsIntervalCount = 0;
    let tagsInterval;
    let loading = true;

    vm.$onInit = () => {

        $scope.tags = $scope.tags || [];

        listeners = [];
        listeners.push($scope.$watch(() => $scope.disabled, () => {
            if (!$scope.disabled) {
                UtilsService.autoCompleteRefreshHack(vm);
            }
        }));

        BookingOptionsManagerService.getAll().then(function(menuOptions) {

            allMenuOptions = menuOptions.filter(function(opt) {
                // you can't have a 'delivery fee' menu option as a child
                return opt.tag !== hardCodedTags.DELIVERY_TAG_ID;
            });

            $scope.tags = $scope.tags.map(t => {
                if (!t.name) {
                    return allMenuOptions.find(o => o._id === t._id);
                }
                return t;
            });

            updateHasArchived();
            filterRemainingMenuOptions();

            loading = false;
        }).catch(function(e) {
            vm.error = e;
            loading = false;
        });
    };

    vm.$onDestroy = () => {
        unregister(listeners);
    };

    function updateHasArchived() {
        vm.hasArchived = $scope.tags.some(o => o.isArchived);
    }

    /**
     * Add a tag to the list
     * @param {Object} tag The tag to remove
     */
    function onAddTag(tagToAdd) {
        if (tagToAdd) {

            const index = vm.remainingMenuOptions.indexOf(tagToAdd);
            vm.remainingMenuOptions.splice(index, 1);
            updateHasArchived();

            setTimeout(() => {
                vm.searchText = '';
                vm.placeholder = null;
            }, 0);

        }
    }

    /** A tag has been removed */
    function removedTag(itemRemoved) {
        filterRemainingMenuOptions();
        updateHasArchived();

        if (vm.remainingMenuOptions.length === 1) {
            UtilsService.autoCompleteRefreshHack(vm);
        }
        vm.placeholder = PLACEHOLDER;
    }

    function filterRemainingMenuOptions() {
        vm.remainingMenuOptions = allMenuOptions.filter(o => {
            const selectedIds = $scope.tags.map(t => t._id);
            // removes child items from the list if they have already been selected
            return !o.isArchived && selectedIds.indexOf(o._id) === -1
                // ensures parent menu option isn't included in child list
                &&
                o._id !== $scope.parentId;
        });
    }

    /**
     * If still loading tags returns a promise until tags have been populated.
     * Otherwise returns immediately.
     */
    function querySearch(query) {
        if (tagsInterval) {
            clearInterval(vm.tagsInterval);
        }

        if (loading) {
            return new Promise(resolve => {
                tagsInterval = setInterval(() => {
                    tagsIntervalCount++;

                    if (tagsIntervalCount >= MAX_TAGS_INTERVALS) {
                        clearInterval(vm.tagsInterval);
                    }

                    if (!loading) {
                        resolve(vm.remainingMenuOptions.filter(createFilterFor(query)));
                    }
                }, 500);
            });
        } else {
            return vm.remainingMenuOptions.filter(createFilterFor(query));
        }
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
        var lowercaseQuery = query.toLowerCase();
        return function filterFn(tag) {
            if (tag && tag.name && tag.name.toLowerCase().indexOf(lowercaseQuery) === 0) {
                return true;
            }
            return false;
        };
    }
}
